import { Chip, useDisclosure } from "@heroui/react";
import { useState, useEffect } from "react";
import { Office } from "@/api/officies/officies.ts";
import { OfficeModal } from "./modals/officeModal";
import { useAppSelector } from "@/hooks/useAppSelector.ts";

export function OfficeChip({ officeId }: { officeId: number }) {
  const [item, setItem] = useState<Office | null>(null);
  const disclosure = useDisclosure();
  const items = useAppSelector((state) => state.handbooks.office);

  useEffect(() => {
    if (officeId === -1) {
      setItem(null);
    } else {
      setItem(items.find((el) => el.id == officeId) || null);
    }
  }, [officeId, items]);

  return (
    <>
      <OfficeModal
        isOpen={disclosure.isOpen}
        onOpenChange={disclosure.onOpenChange}
        item={item!}
      />
      {officeId === -1 && (
        <Chip variant="dot" color="danger">
          удалено
        </Chip>
      )}
      {officeId !== -1 && item !== null && (
        <Chip
          className="cursor-pointer"
          onClick={disclosure.onOpen}
          variant="dot"
          color="primary">
          {item?.display_name}
        </Chip>
      )}
      {officeId !== -1 && item == null && (
        <Chip variant="dot" color="default">
          н/д
        </Chip>
      )}
    </>
  );
}
